import type { Partner_Partner as EmbeddedPartner } from '__generated__/graphql-types-do-not-use';

import type { PartnerFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/SharedCommonEntitiesFragments';
import type {
  WeeklyMaterialFragment,
  WeeklyMaterialItemFragment,
} from 'bundles/unified-description-page-common/queries/bff/__generated__/SharedCourseEntitiesFragments';

/**
 * Returns list of partners who have their content embedded within any course material.
 * @param weeks - list of weekly materials for a course
 * @param authoringPartners - list of partners who authored the course
 * @returns list of unique embedded partners, sorted by name
 */
const getUniqueEmbeddedPartners = (weeks?: WeeklyMaterialFragment[], authoringPartners?: PartnerFragment[] | null) => {
  const partners: Array<EmbeddedPartner> = [];
  if (!weeks) return partners;

  const authoringPartnerIDs = authoringPartners?.map((partner) => partner.id) || [];

  const materialTypes: Array<keyof WeeklyMaterialFragment> = ['assessments', 'lectures', 'supplements'];

  weeks.forEach((week) => {
    materialTypes.forEach((materialType) => {
      const materials = week[materialType];

      if (!materials) return;

      // @ts-expect-error Duration: string
      materials.forEach((item: WeeklyMaterialItemFragment) => {
        const itemPartners = item.partners;

        if (!itemPartners) return;

        itemPartners.forEach((partner) => {
          const isPartnerAlreadyIncluded = partners.some((existingPartner) => existingPartner.id === partner.id);

          if (!isPartnerAlreadyIncluded && !authoringPartnerIDs.includes(partner.id)) {
            partners.push(partner);
          }
        });
      });
    });
  });

  return partners.sort((a, b) => a.name.localeCompare(b.name));
};

export default getUniqueEmbeddedPartners;
